import React, { PureComponent } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { connect } from 'react-redux';
import FormikCheckbox from '../../../ui/FormikCheckbox';
import { FilePond, registerPlugin } from 'react-filepond';
import { create } from '../../../../react-doka/lib/doka.esm.min';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

import { UserInfo2Schema } from '../../validation';

import { updateProfilePhoto, updateFormData } from '../../actions';
import { cropMask, cropProps } from '../../../user/profile-component';
import { PAGE_ROUTES } from '../../../../constants/pageRoutes';
import { getQueryRedirectLink, navigateTo } from '../../../global/actions';

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImagePreview,
  FilePondPluginImageEdit,
  FilePondPluginImageTransform,
  FilePondPluginFileValidateType
)

const referralOptions = [
  { label: "Online search", value: "online-search" },
  { label: "Social media", value: "social-media" },
  { label: "E-mail", value: "email" },
  { label: "Friend", value: "friend" },
  { label: "Article/blog", value: "blog" },
  { label: "Event", value: "event" },
  { label: "Referral", value: "other" }
];

const mapStateToProps = state => ({
  registration: state.Registration
});

export const onProfileCompletionSkip = (dispatch) => {
  let redirectLink = getQueryRedirectLink();
  redirectLink = redirectLink ? redirectLink : PAGE_ROUTES.DASHBOARD;
  dispatch(navigateTo(redirectLink));
}

class UserInfo2Form extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.setInitialState();
  }

  setInitialState() {
    if (this.props.registration && this.props.registration.photo) {
      this.pond.addFile(this.props.registration.photo);
    }
  }

  handleProcess = (name, file, metadata, load) => {
    let { dispatch } = this.props;
    let photo = file;

    if (photo) {
      this.form.setFieldValue('profilePhoto', photo.name);
      dispatch(updateProfilePhoto(photo));
    }
    return load ? load(Date.now()) : Promise.resolve(true);
  }

  handleRemove = (error, file) => {
    if (file) {
      this.form.setFieldValue('profilePhoto', '');
      this.props.dispatch(updateProfilePhoto(null));
    }
  }

  removeLoyalty = (field, form, loyaltyToRemove) => {
    if (!loyaltyToRemove) return;
    let loyalties = form.values.profileLoyalties.filter((l) => l !== loyaltyToRemove);
    form.values.profileLoyalties = loyalties;
    this.props.dispatch(updateFormData(form.values));
  }

  addLoyalty = (field, form) => {
    if (!field.value || form.values.profileLoyalties.indexOf(field.value) !== -1) return;

    let loyalties = form.values.profileLoyalties.slice(0);
    loyalties = loyalties.concat(field.value);
    form.values.profileLoyalties = loyalties;
    form.values.newLoyalty = '';
    this.props.dispatch(updateFormData(form.values));
  }

  render() {
    let { onSubmit, onBack } = this.props;
    let values = this.props.registration.formData;
    return (
      <Formik
        ref={ref => (this.form = ref)}
        validationSchema={UserInfo2Schema}
        initialValues={values}
        onSubmit={onSubmit}>
        {({ values, errors, touched }) => (
          <Form>
            <div><i className="fas fa-asterisk required-asterisk"></i> Indicates required field</div>
            {/* <h3>Create Password</h3> */}
            <div>
              {/* <div className="fieldgroup fieldgroup-required">
                            <Field
                                name="password"
                                type="password"
                                placeholder="Enter password"
                                className={ (errors.password && touched.password) ? "form-control error-input" : "form-control"}
                            />
                            <ToolTip position="right" message={toolTipMessage}><i className="far fa-question-circle"></i></ToolTip>
                            <ErrorMessage name="password" component="div" className="error-message" />
                        </div>
                        <div className="fieldgroup fieldgroup-required">
                            <Field
                                name="passwordConfirm"
                                type="password"
                                placeholder="Re enter password"
                                className={ (errors.passwordConfirm && touched.passwordConfirm) ? "form-control error-input" : "form-control"}
                            />
                            <ErrorMessage name="passwordConfirm" component="div" className="error-message" />
                        </div> */}
              <h3>Profile Photo <i className="fas fa-asterisk required-asterisk"></i></h3>
              <span>A profile picture of your face is required for fraud protection and the safety of you and our hosts.</span>
              <div className="row mt-3 mb-3">
                <div className="col">
                  <Field
                    name="profilePhoto">
                    {() => (
                      <FilePond
                        ref={ref => (this.pond = ref)}
                        labelIdle='<span class="filepond--label-action">Upload Image</span>'
                        allowMultiple={false}
                        acceptedFileTypes={['image/png', 'image/jpeg', 'image/tiff']}
                        imageCropAspectRatio='1:1'
                        imagePreviewHeight={150}
                        stylePanelLayout='compact circle'
                        styleLoadIndicatorPosition='center bottom'
                        styleProgressIndicatorPosition='right bottom'
                        styleButtonRemoveItemPosition='left bottom'
                        styleButtonProcessItemPosition='right bottom'
                        server={{
                          process: this.handleProcess
                        }}
                        imageEditEditor={create({
                          crop: cropProps,
                          cropMask: cropMask
                        })}
                        onremovefile={this.handleRemove}
                      />

                    )}
                  </Field>
                  <ErrorMessage name="profilePhoto" component="div" className="error-message" />
                </div>
              </div>
              <h3 className="mt-3">About Me (optional)</h3>
              <span>Help property owners get to know you a little better</span>
              <div className="fieldgroup">
                <Field
                  name="profileAbout"
                  component="textarea"
                  className="form-control"
                />
              </div>
              <h3>Where do your loyalties lie? (optional)</h3>
              <span>Start typing the name of the college or university you follow most loyally. Add up to 5 schools.</span>
              <div className="row">
                <div className="col-12">
                  <ul className="mt-3">
                    {values.profileLoyalties.map((loyalty, index) => {
                      return (
                        <li key={index}>
                          <Field name="profileLoyalties">
                            {({ field, form }) => (
                              <div>
                                <span>{loyalty}</span>
                                <i className="fas fa-times ml-3"
                                  onClick={() => { this.removeLoyalty(field, form, loyalty); }} />
                              </div>
                            )}</Field>
                        </li>
                      )
                    })}
                  </ul>
                </div>
                {(values.profileLoyalties.length < 5) &&
                  (<div className="col">
                    <Field
                      name="newLoyalty">
                      {({ field, form }) => (
                        <div className="row fieldgroup">
                          <div className="col-9 pl-0">
                            <input type="text"
                              className="form-control"
                              name={field.name}
                              value={field.value}
                              onChange={(e) => { form.setFieldValue(field.name, e.target.value) }}
                              placeholder="School Name" />
                          </div>
                          <div className="col-3 p-0">
                            <label className="btn btn-secondary w-100"
                              onClick={() => this.addLoyalty(field, form)}>Add</label>
                          </div>
                        </div>
                      )}
                    </Field>
                  </div>)
                }
              </div>
              <h3>How did you hear about us?<i className="fas fa-asterisk required-asterisk"></i></h3>
              <span>(Check all that apply)</span>
              <div className="row">
                <div className="col-12">
                  <div className="fieldgroup">
                    {referralOptions.map((o, i) => <div key={`referral-${i}`}><FormikCheckbox
                      name="referralType"
                      label={o.label}
                      value={o.value}
                    /></div>)}
                    <ErrorMessage name="referralType" component="div" className="error-message" />
                  </div>
                  {values.referralType.indexOf('other') > -1 && (
                    <div className="fieldgroup fieldgroup-required">
                      <Field
                        name="referralText"
                        type="text"
                        placeholder="Referrer Name or Code"
                        className={(errors.referralText && touched.referralText) ? "form-control error-input" : "form-control"} />
                      <ErrorMessage name="referralText" component="div" className="error-message" />
                    </div>)}
                </div>
              </div>
            </div>
            <div className="button-row row mt-3">
              <div className="col pl-3">
                <label onClick={onBack}>Back</label>
              </div>
              <div className="col text-right submit-btn">
                <button className="btn btn-primary" style={{ width: 120, marginTop: -15 }} type="submit">Next</button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    )
  }
}

export default connect(mapStateToProps)(UserInfo2Form);
